module.exports = __webpack_public_path__ + "img/zsnp.e4bf8643.png";